import * as React from 'react';

const Calendar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={18} viewBox="0 0 18 18" {...props}>
        <defs>
            <filter id="calendar_a" width="113.3%" height="183.3%" x="-6.7%" y="-33.3%" filterUnits="objectBoundingBox">
                <feOffset dy={4} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={6} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0.229949097 0 0 0 0 0.461254077 0 0 0 0 0.62647192 0 0 0 0.04 0"
                />
                <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter2" />
                <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation={2} />
                <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
                <feColorMatrix
                    in="shadowBlurOuter2"
                    result="shadowMatrixOuter2"
                    values="0 0 0 0 0.231372549 0 0 0 0 0.462745098 0 0 0 0 0.62745098 0 0 0 0.02 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
            </filter>
            <rect id="calendar_b" width={300} height={48} x={0} y={0} rx={24} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M-25-96h320v1792H-25z" />
            <g transform="translate(-15 -14)">
                <use xlinkHref="#calendar_b" fill="currentColor" filter="url(#calendar_a)" />
                <rect
                    width={299}
                    height={47}
                    x={0.5}
                    y={0.5}
                    fill="#FFF"
                    stroke="currentColor"
                    strokeLinejoin="miter"
                    rx={23.5}
                />
            </g>
            <g
                fillRule="nonzero"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                transform="translate(1 1)"
            >
                <rect width={15} height={13} x={0.501} y={2.5} rx={1} />
                <path d="M.501 6.5h15M4.501 4V.5M11.501 4V.5" />
            </g>
        </g>
    </svg>
);
export default Calendar;
